const cookieKeyPrefix = 'ic-user-'
const storageKeyPrefix = 'ic-'

const environment = {
  urls: {
    login: '/login/',
    register: '/register/',
    admin: '/admin/',
    responder: '/responder/',
    answer: '/answer/',
    shared: '/shared/',
  },
  // urls

  emails: {
    support: 'support@incrowdnow.com',
    salesLead: 'website-leads@incrowdnow.com',
    professionRequest: 'new-profession-request@incrowdanswers.com',
  },

  noticeAccessor: 'shared-ic-notice',
  impAuthIdKey: 'impAuthId',

  appIds: [
    'login',
    'register',
    'admin',
    'responder',
    'answer',
  ],

  referralProgram: {
    payoutBusinessDays: 2,

    // These aren't currently accessible via the API (2016-12-06), so
    // hard-coding them centrally.
    bonusAmounts: {
      physician: 20,
      nonPhysician: 10,
    },
  },

  inBrowser: typeof window !== 'undefined',

  cookieKeys: {
    id: `${cookieKeyPrefix}id`,
    token: `${cookieKeyPrefix}token`,
    surveyId: 'ic-survey-id',
  },

  storageKeys: [
    ['id', 'userId'],
    'token',
    'language',
    'country',
  ]
  .map(key => Array.isArray(key) ? key : [key, key])
  .reduce((storageKeys, [key, value]) => {
    storageKeys[key] = `${storageKeyPrefix}${value}`
    return storageKeys
  }, {}),

  ENVS: {
    LOCAL: 'local',
    DEV: 'develop',
    QA: 'qa',
    QUAL_QA: 'qual-qa',
    PROD: 'production',
  },

  userRoles: {
    ADMIN: 'ADMIN',
    SUPER_ADMIN: 'SUPER ADMIN',
    RESPONDER: 'RESPONDER',
    CALL_CENTER: 'CALL CENTER USER',
    LIST_MATCH_USER: 'LIST MATCH USER',
    BETA_USER: 'BETA USER',
    QUAL_SCHEDULER_ADMIN: 'QUAL SCHEDULER ADMIN',
    QUAL_SCHEDULER_MANAGER: 'QUAL SCHEDULER MANAGER',
    QUAL_SCHEDULER_USER: 'QUAL SCHEDULER USER',
  },

  intercomId: 'fwoul26y',
}

const { ENVS } = environment
environment.hostToEnv = {
  '10.1.10.46:3001': ENVS.LOCAL,
  'localhost:3001': ENVS.LOCAL,

  'web-qa.incrowdanswers.com': ENVS.QA,
  'ic-web-qa.incrowdanswers.com': ENVS.QA,

  'qual-qa.incrowdanswers.com': ENVS.QUAL_QA,

  'www.incrowdanswers.com': ENVS.PROD,
  'incrowdanswers.com': ENVS.PROD,

  'web-dev.incrowdanswers.com': ENVS.DEV,
}

export default environment
